module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/upplasttext_100x56-9be956d28a0cfd761ef32f93ea909f4d.png";